import { AppID, ContentAppsHtmlStructure } from './types'

export const setObjectFromApp = (data: HTMLElement[]) => {
    let apps: any = {}
    data.forEach((el: HTMLElement) => {
      switch (el.id) {
        case (AppID.INTBDASHBOARD): {
          apps.intbDashboardApp = el;
          break;
        }
        case (AppID.TBCFDASHBOARD): {
          apps.tbcfDashboardApp = el;
          break;
        }
        case (AppID.INTB): {
          apps.intbApp = el;
          break;
        }
        case (AppID.TBCF): {
          apps.tbcfApp = el;
          break;
        }
        case (AppID.ALC): {
          apps.alcApp = el;
          break;
        }
        case (AppID.CONTROL): {
          apps.controlApp = el;
          break;
        }
      }
    })
    return apps as ContentAppsHtmlStructure;
  }
  export const displayVersion = () => {
    console.log("%cApp version: v5.2.4 ","color: green; font-size: 20px");
  }